import { render, staticRenderFns } from "./teacherItem.vue?vue&type=template&id=a02c2b9c&scoped=true&"
import script from "./teacherItem.vue?vue&type=script&lang=js&"
export * from "./teacherItem.vue?vue&type=script&lang=js&"
import style0 from "./teacherItem.vue?vue&type=style&index=0&id=a02c2b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02c2b9c",
  null
  
)

export default component.exports